import { render, staticRenderFns } from "./ElementsCreate.vue?vue&type=template&id=064b1bc8&"
import script from "./ElementsCreate.vue?vue&type=script&lang=js&"
export * from "./ElementsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports